import React from "react";
import Box from "react-raster";
import { theme } from "src/config";
import styled from "styled-components";
export interface IClockButtonProps {
  idx: number;
  radius: number | string;
  numItems: number;
  selected?: boolean;
  onClick(): void;
}
const ClockButtonStyled = styled.div<{
  radius: number | string;
  numItems: number;
  idx: number;
}>`
  border-radius: 50%;
  position: absolute;
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.small};
  color: ${theme.font.color.darkGray};
  top: 50%;
  left: 50%;
  --rot: calc(${(props) => props.idx}*1turn / ${(props) => props.numItems});
  transform: translate(-50%, -50%) rotate(var(--rot))
    translate(0px, -${(props) => props.radius}) rotate(calc(-1 * var(--rot)));

    :hover {
      border-radius: 50%;
      background-color: ${theme.color.hover};
      background-position: fixed;
      padding: 0.5rem 0.5rem;
      cursor: pointer;
    }
`;

export const ClockButton: React.FC<IClockButtonProps> = (
  props: React.PropsWithChildren<IClockButtonProps>
): JSX.Element => {
  const { idx, radius, numItems, onClick, selected } = props;
  return (
    <ClockButtonStyled
      idx={idx % 12}
      radius={`${radius}px`}
      numItems={numItems}
    >
      <Box
        height={"2em"}
        width={"2em"}
        alignItems="center"
        justifyContent="center"
        display="flex"
        onClick={onClick}
      >
        {props.children}
      </Box>
    </ClockButtonStyled>
  );
};
